import { isValid } from "../../utils/utilitiesmodule";
import "../../utils/messages";
import { BACKUP_MESSAGES } from "../../utils/messages";
import moment from "moment";

export function assignBackupRequests(api) {
    /****************************************BACKUP**************************************************************************************/
    //export const backupAPI = {
    //STEP 0 = async function creare i vari id (job, sources, destinations)
    //vedere con andrea
    api.createBackup = async function (backupObj) {
        var config = this.buildConfig();
        var body = JSON.stringify(backupObj);
        var clientMessage = null
        var response = await api.post('/enterprise/jobs', body, config)
            .then(res => res.data)
            .catch(e => {
                clientMessage = this.checkError(e, BACKUP_MESSAGES.NOT_CREATED, { 0: backupObj.name });
                return null;
            });

        //In caso di successo, il comando di edit viene passato all'agent, quindi sarà l'agent a dare la vera risposta
        //In caso di fallimento, il comando non viene passato all'agent, quinid è il client a dare la risposta
        if (clientMessage != null) {
            this.emitFunction("sendClientMessage", clientMessage, "backupmethods");
        }
        return response;
    }

    api.setNotification = async function (idJob, enabled) {
        var body = {
            "id": idJob,
            "enabled": enabled ? 1 : 0
        };
        var response = await api.put("/enterprise/notifications/jobs", body, this.buildConfig())
            .then(res => res)
            .catch(e => {
                this.checkError(e, BACKUP_MESSAGES.NOTIFICATIONS_NOT_RETRIEVED);
                return [];
            });
        enabled ? this.createToastFunction(this.translateFunction(BACKUP_MESSAGES.ADD_TO_NOTIFICATIONS), "SUCCESS") : this.createToastFunction(this.translateFunction(BACKUP_MESSAGES.REMOVE_FROM_NOTIFICATIONS), "SUCCESS");
        return response;
    }

    api.editBackup = async function (backupObj) {
        var config = this.buildConfig();
        var body = JSON.stringify(backupObj);
        var clientMessage = null;

        var response = await api.put('/enterprise/jobs', body, config)
            .then(res => res.data)
            .catch(e => {
                clientMessage = this.checkError(e, BACKUP_MESSAGES.NOT_MODIFIED, { 0: backupObj.name });
                return null;
            });

        //In caso di successo, il comando di edit viene passato all'agent, quindi sarà l'agent a dare la vera risposta
        //In caso di fallimento, il comando non viene passato all'agent, quinid è il client a dare la risposta
        if (clientMessage != null) {
            this.emitFunction("sendClientMessage", clientMessage, "backupmethods");
        }

        return response;
    }

    api.deleteBackup = async function (id, name) {
        var config = this.buildConfig();

        var response = await api.delete('/enterprise/jobs/' + id, config)
            .then(res => 200 <= res.status && res.status <= 299)
            .catch(e => {
                this.checkError(e, BACKUP_MESSAGES.NOT_DELETED, { 0: name });
                return false;
            });

        return response;
    }

    api.renameBackup = async function (idBackup, oldName, newName) {
        var config = this.buildConfig();
        var body = JSON.stringify({ name: newName });

        var response = await api.put('/enterprise/jobs/rename/' + idBackup, body, config)
            .then(res => 200 <= res.status && res.status <= 299)
            .catch(e => {
                this.checkError(e, BACKUP_MESSAGES.NOT_RENAMED, { 0: oldName, 1: newName });
                return false;
            });

        return response;
    }
    /*
    Ritorna un oggetto del tipo
    {
        id: ...,
        name : ... , 
        sources : [],
        destinations : [],
        scheduling : []
    }*/
    api.getBackupWithID = async function (idBackup) {
        var response = await api.get('/enterprise/jobs/' + idBackup + "?fview=true", this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, BACKUP_MESSAGES.NOT_RETRIEVED, { 0: idBackup });
                return null;
            });

        return response;
    }

    api.getBackupLogs = async function (idBackup, onlyOk = true) {

        //[TG - 14/10/2024 ?result=1 filtra solo i log terminati con successo, 
        // quindi ciò determina che il restore dei log che sono parzialmente in errore dovrà essere fatto col restore manuale]
        var url = '/enterprise/logs/job/' + idBackup;
        if (onlyOk) {
            url += '?result=1';
        }
        var response = await api.get(url, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, BACKUP_MESSAGES.LOGS_NOT_RETRIEVED);
                return [];
            });
        return response;
    }

    api.getBackups = async function (filter) { //offset -> punto di inizio, index -> quanti elementi prendere
        var params = "index=" + filter.limit + "&offset=" + filter.offset + "&excludeNeverExec=" + 0 + "&searchPhrase=" + filter.backupName;
        if (isValid(filter.id_pc)) {
            params += "&pc=" + filter.id_pc
        }
        if (isValid(filter.id_group)) {
            params += "&group=" + filter.id_group
        }
        if (isValid(filter.lastResult)) {
            params = params + "&level=" + filter.lastResult;
        }


        var response = await api.get('/enterprise/jobs?' + params, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, BACKUP_MESSAGES.LIST_NOT_RETRIEVED);
                return [];
            });
        return response;
    }

    api.getBackupJobsForRestore = async function (idPC, includeDeletedJobs) {
        var response = await api.get("/enterprise/jobs/computer/" + idPC + "?includeDeleted=" + includeDeletedJobs, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, BACKUP_MESSAGES.LIST_NOT_RETRIEVED);
                return [];
            });
        return response;
    }

    api.getNotifications = async function () {
        var response = await api.get('/enterprise/notifications/jobs', this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, BACKUP_MESSAGES.NOTIFICATIONS_NOT_RETRIEVED);
                return [];
            });
        return response;
    }


    api.getIdleBackups = async function () {
        var response = await api.get('/enterprise/jobs/zombies/1', this.buildConfig())
            .then(res => res.data.map(x => {
                if (!isValid(x.type_name) || x.type_name.toLowerCase() == "unknown")
                    x.type_name = this.$ONEServiceTypeInfo[x.type].name;
                return x;
            }))
            .catch(e => {
                this.checkError(e, BACKUP_MESSAGES.LIST_NOT_RETRIEVED);
                return [];
            });

        return response;
    }
    api.getBackupTree = async function () {
        var response = await api.get('/enterprise/groupstree?excludeGroups=1', this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, BACKUP_MESSAGES.LIST_NOT_RETRIEVED);
                return null;
            });

        return response;
    }
    //[TG - legge la configurazione del backup dal singolo log]
    api.getBackupLogConfiguration = async function (logId) {
        var response = await api.get('/enterprise/backupconfigurations?lid=' + logId, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, BACKUP_MESSAGES.LOG_DETAIL_NOT_RETRIEVED);
                return null;
            });
        return response;
    }

    api.getBackupStats = async function (stats) {
        var url = 'enterprise/stats/backup';
        url += '?dt_start=' + moment(stats.dt_inf).format("YYYYMMDDhhmmss");
        url += '&dt_end=' + moment(stats.dt_sup).format("YYYYMMDDhhmmss");
        url += '&idg=' + stats.id_group;
        var response = await api.get(url, this.buildConfig())
            .then(res => {
                if (res.status == 400) {
                    console.writeError(res.data.message);
                    return null;
                }

                return res.data;
            }).catch(e => {
                this.checkError(e, GET_BACKUP_STATS_ERR);
                return null;
            });

        return response;

    }
}
